<template>
    <generic-page>
        <back-to-settings />

        <div class="d-flex align-items-center justify-content-between mt-3">
            <h5 class="mb-0">Calls</h5>
            <camera-preview />
        </div>

        <div class="py-2">
            <div v-if="loading">
                <generic-loading />
            </div>
            <div v-else>
                <div
                    :key="call.id"
                    v-for="call in calls"
                    @click="
                        $router.push({
                            name: 'accountCallView',
                            params: {
                                id: call.defaultMap.id,
                            },
                        })
                    "
                >
                    <user-standard-avatar
                        :standardMap="call.standardMap"
                        :timestamp="call.defaultMap.created"
                        :nonPrimaryPhotos="false"
                        :hideBadges="true"
                        :userBetweenStatus="false"
                        size="small"
                        class="border-light border-top"
                    >
                        <div class="small">
                            {{ call.defaultMap.status }}
                        </div>

                        <div class="small text-secondary">
                            <span>
                                {{ call.defaultMap.duration }}
                            </span>
                        </div>
                    </user-standard-avatar>
                </div>
            </div>
        </div>

        <generic-pagination
            @next="next"
            @previous="previous"
            :hasMorePages="hasMorePages"
            :page="page"
        />
    </generic-page>
</template>

<script>
import BackToSettings from "@/components/setting/utility/BackToSettings";
import GenericPagination from "@/components/utility/GenericPagination";
import UserStandardAvatar from "@/components/user/UserStandardAvatar";
import CameraPreview from "@/components/agora/CameraPreview";

export default {
    data() {
        return {
            page: 1,
            hasMorePages: false,
            calls: null,
            loading: false,
        };
    },
    created() {
        this.refresh();
    },
    methods: {
        next() {
            this.page++;
            this.refresh();
        },
        previous() {
            this.page--;
            this.refresh();
        },
        refresh() {
            this.loading = true;

            this.api
                .post("/call/index", {
                    page: this.page,
                })
                .then((response) => {
                    this.calls = response?.data?.calls;
                    this.hasMorePages = response?.data?.hasMorePages;
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
    },
    components: {
        BackToSettings,
        GenericPagination,
        UserStandardAvatar,
        CameraPreview,
    },
};
</script>